
// Set up IntersectionObserver to toggle sticky class dynamically
const observer = new IntersectionObserver((entries) => {
entries.forEach(entry => {
    const stickyEl = entry.target;

    if (!stickyEl) return;

    if (entry.intersectionRatio === 0) {
    stickyEl.classList.add('is-sticky');
    } else if (entry.intersectionRatio === 1) {
    stickyEl.classList.remove('is-sticky');
    }
});
}, { threshold: [0, 1] });

// Observe all sentinels with [data-track-sticky-state]
document.querySelectorAll('[data-track-sticky-state]').forEach(sentinel => {
observer.observe(sentinel);
});
